import React, { useEffect, useRef, useState } from "react";

const DeferredSection = ({
  children,
  fallback = null,
  minHeight = 0,
  rootMargin = "300px 0px",
  className = "",
}) => {
  const containerRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (shouldRender) {
      return undefined;
    }

    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      setShouldRender(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setShouldRender(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    const currentElement = containerRef.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => observer.disconnect();
  }, [rootMargin, shouldRender]);

  if (shouldRender) {
    return children;
  }

  return (
    <div
      ref={containerRef}
      className={className}
      style={minHeight ? { minHeight } : undefined}
      aria-hidden="true"
    >
      {fallback}
    </div>
  );
};

export default DeferredSection;
